import { useState } from 'react';
import useSWR from 'swr';
import { useDebounce } from 'use-debounce';
// api
import getFilteredCarriers from 'modules/emergencies/api/getFilteredCarriers';

// returns selectedFilters and functions to update them
const useCarriersFilter = ({ initialQuery = '' }) => {
  const initialSelectedFilters = {
    search: initialQuery,
  };

  const [internalSelectedFilters, setInternalSelectedFilters] = useState(initialSelectedFilters);
  const [selectedFilters] = useDebounce(internalSelectedFilters, 500);

  const filtersKey = JSON.stringify(selectedFilters);
  const { data: carriers, error: carriersError } = useSWR(
    `/carriers/${filtersKey}`,
    () => getFilteredCarriers(internalSelectedFilters.search), //change this only allows segments
    {
      errorRetryCount: 0,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const isLoadingCarriers = typeof carriers === 'undefined' && !carriersError;

  let carrierOptions = [];

  if (carriers) {
    carrierOptions = (carriers?.results || []).map((carrier) => ({
      value: carrier.id,
      label: carrier.name,
      display: carrier.name,
      search: `${carrier.name} ${carrier.id}`,
    }));
  }

  const setSearch = (value) => {
    setInternalSelectedFilters({
      ...internalSelectedFilters,
      search: value,
    });
  };

  return {
    internalSelectedFilters,
    carrierOptions,
    carrierOptionsError: carriersError,
    isLoadingCarrierOptions: isLoadingCarriers,
    setSearch,
  };
};

export default useCarriersFilter;
